import React, { useState } from "react";
import Toast from "../components/Toast";
import AdminPage from "../Pages/AdminPage";
import "./AdminRoute.css";
const ADMIN_EMAIL = "shizasultan117@gmail.com"; // only this email can access admin

export default function AdminRoute() {
  const [email, setEmail] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [showPopup, setShowPopup] = useState(true);
  const [toast, setToast] = useState({ show: false, type: "info", message: "" });

  const handleLogin = () => {
    if (email.trim() === ADMIN_EMAIL) {
      setIsAdmin(true);
      setShowPopup(false);
      setToast({ show: true, type: "success", message: "Admin login successful!" });
      setTimeout(() => setToast({ show: false }), 2500);
    } else {
      setToast({ show: true, type: "error", message: "Restricted Admin!" });
      setTimeout(() => setToast({ show: false }), 2500);
    }
    setEmail("");
  };

  return (
    <>
      {isAdmin && <AdminPage />}
      {showPopup && !isAdmin && (
        <div className="admin-popup-overlay">
          <div className="admin-popup-container">
            <h2>Admin Login</h2>
            <input
              type="email"
              placeholder="Enter admin email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button onClick={handleLogin} className="btn-login">Login</button>
          </div>
        </div>
      )}
      <Toast show={toast.show} type={toast.type} message={toast.message} />
    </>
  );
}
